import * as React from 'react';
import { COLOR_A, COLOR_B } from './CONSTANTS';
import { cumulativeOffset } from './utilities';
import './Keys.css';

const Key = ({ setNote, stopNote, midiNumber, numberOfNotes, note, releaseTime, loadProgress, modulateNote }) => {
	const [isDown, setDown] = React.useState(false);

	const gliss = false;

	const [fade, setFade] = React.useState(false);

	let useTouchEvents = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
	const down = () => {
		setDown(true);
		setNote();
		setFade(false);
	};
	const up = () => {
		setDown(false);
		stopNote();
		setFade(true);
	};

	const key = React.useRef(null);

	return (
		<div
			ref={key}
			onMouseDown={useTouchEvents ? null : down}
			onMouseUp={useTouchEvents ? null : up}
			// onMouseEnter={gliss ? down : null}
			onMouseLeave={isDown?up:null}
			onTouchStart={e => {
				if (useTouchEvents) {
					var newValue =
						(-2 *
							(e.targetTouches[0].clientY -
								(cumulativeOffset(key.current).top + key.current.offsetHeight / 2))) /
						key.current.offsetHeight;
					modulateNote(newValue);
					down();
				}
			}}
			onTouchCancel={useTouchEvents ? up : null}
			onTouchEnd={useTouchEvents ? up : null}
			onTouchMove={e => {
				if (isDown) {
					var newValue =
						(-2 *
							(e.targetTouches[0].clientY -
								(cumulativeOffset(key.current).top + key.current.offsetHeight / 2))) /
						key.current.offsetHeight;
					modulateNote(newValue);
				}
			}}
			onAnimationEnd={() => setFade(false)}
			style={{
				// background: isDown ?  'white':'transparent',
				// background: (note===0||note===12)?COLOR_A:(note===3||note===7)?COLOR_B:"transparent",

				// width: 100/(numberOfNotes)+"%",
				flexGrow: 1,
				height: '100%',
			}}
		>
			<div
				className={(fade ? 'fading ' : '') + (isDown ? 'down' : ' ')}
				style={{
					boxSizing: 'border-box',
					animationDuration: 0.9 * releaseTime + 's',
					// background: isDown ?  'white':'transparent',
					// background: (note===0||note===12)?COLOR_A:(note===3||note===7)?COLOR_B:"transparent",
					// background: `hsl(${180 + (180 * (midiNumber % 12)) / 12},20%,${20 + Math.floor(midiNumber / 12) * 5}%)`,
					background: note === 0 || note == 5 ? COLOR_A : COLOR_B,
					// width: 100/(numberOfNotes)+"%",
					flexGrow: 1,
					height: '95%',
					width: '95%',
					boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
					borderRadius: '0.2rem',
				}}
			/>
			{/* <div style={{textAlign: "center", marginTop:"50%"}}>{note===0?".":""}</div> */}
		</div>
	);
};

const Keys = ({ setNote, stopNote, octave, offset, releaseTime, root, loadProgress, modulateNote }) => {
	const scale = [0, 2, 3, 5, 7, 9, 10];

	const keys = [1, 1, 1, 1, 1, 1, 1];

	// const midiNumbers = scale.map(n => n + octave * 12+offset);

	return (
		<div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%', justifyContent: 'center' }}>
			{keys.map((n, idx) => {
				const midiNumber =
					scale[(idx + offset) % scale.length] + Math.floor((idx + offset) / scale.length) * 12 + octave * 12;
				return (
					<Key
						key={idx}
						releaseTime={releaseTime}
						note={scale[(idx + offset) % scale.length]}
						numberOfNotes={scale.length}
						midiNumber={midiNumber}
						setNote={() => setNote(midiNumber + root)}
						stopNote={() => stopNote(midiNumber + root)}
						modulateNote={v => modulateNote(midiNumber + root, v)}
						loadProgress={loadProgress}
					/>
				);
			})}
		</div>
	);
};

export default Keys;
